import { Avatar, ButtonBase, Grid, IconButton, Menu, MenuItem } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import i18n from "config/i18n";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import React from "react";
import { useNavigate } from "react-router-dom";
import StyledCheckbox from "ui/Checkbox";
import { profilStyles } from "./style";

interface profilProps {
  user: string;
  admin: boolean;
  accountName: string;
  companyName: string;
}

export const Profil = ({ user, admin, accountName, companyName }: profilProps) => {
  const style = profilStyles();
  const { text } = useText();
  const [dropMenu, setDropMenu] = React.useState<null | HTMLElement>(null);

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const [currentLangage, setCurrentLangage] = React.useState("EN");

  React.useEffect(() => {
    setCurrentLangage(i18n.language.toUpperCase());
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setDropMenu(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setDropMenu(null);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setDropMenu(null);
    }
  }

  const profilePage = () => {
    navigate("/users/profile");
    setDropMenu(null);
  };

  const clientPage = () => {
    navigate("/client");
    setDropMenu(null);
  };

  const userPage = () => {
    navigate("/users");
    setDropMenu(null);
  };

  const addressPage = () => {
    navigate("/address");
    setDropMenu(null);
  };
  const onLogout = () => {
    navigate("/logout");
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (lng === "en") {
      setCurrentLangage("EN");
      setDropMenu(null);
    } else {
      setCurrentLangage("FR");
      setDropMenu(null);
    }
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        aria-controls={dropMenu ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar component={ButtonBase} src={user} variant="circular" className={style.avatarStyle} />
      </IconButton>
      <Menu
        id="country-select-menu"
        anchorEl={dropMenu}
        keepMounted
        open={Boolean(dropMenu)}
        onClose={handleClose}
        className={style.menuList}
        PaperProps={{
          style: {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            minWidth: 250,
            marginTop: 48,
          },
        }}
      >
        <MenuItem>
          <Grid container className={style.userInfos}>
            <Grid xs={2}>
              <Avatar alt="avatar" src={user} />
            </Grid>
            <Grid xs={8} className={style.userGrid}>
              <span>{accountName}</span>
              <span className={style.companyName}>{companyName}</span>
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={profilePage}>
          <Grid container className={style.items}>
            <Grid xs={9}>{text.all.my_profile}</Grid>
            <Grid xs={3}>
              <ChevronRight />
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={clientPage}>
          <Grid container className={style.items}>
            <Grid xs={9}>{text.all.my_clients}</Grid>
            <Grid xs={3}>
              <ChevronRight />
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={userPage}>
          <Grid container className={style.items}>
            <Grid xs={9}>{text.all.users}</Grid>
            <Grid xs={3}>
              <ChevronRight />
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={addressPage}>
          <Grid container className={style.items}>
            <Grid xs={9}>{text.all.my_address}</Grid>
            <Grid xs={3}>
              <ChevronRight />
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <Grid container className={style.items}>
            <Grid xs={9}>{text.all.logout}</Grid>
            <Grid xs={3}>
              <ChevronRight />
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex" }}>
            <StyledCheckbox
              checked={currentLangage === "EN"}
              onChange={() => changeLanguage("en")}
              className={style.checkbox}
            />
            <p style={{ color: currentLangage === "EN" ? COLORS.primary : COLORS.secondary }}>EN</p>
          </div>
          <div style={{ display: "flex" }}>
            <StyledCheckbox
              checked={currentLangage === "FR"}
              onChange={() => changeLanguage("fr")}
              className={style.checkbox}
            />
            <p style={{ color: currentLangage === "FR" ? COLORS.primary : COLORS.secondary }}>FR</p>
          </div>
        </MenuItem>
      </Menu>
    </>
  );
};
